import { combineReducers, createReducer } from '@reduxjs/toolkit';

import { dialogClosed } from 'Core/actions/dialog';
import {
  clearVehicleDialogRequest,
  discardVehicleValue,
  replaceVehicleValue,
  setVehicleDialogSelection,
  vehicleDiscardingRequested,
  vehicleSelected,
} from 'Core/actions/fitmentSearch/index';
import type { VehicleValue } from 'Models/vehicle';

import { updateVehicleSelection } from '../common';

// Dialog selection is intentionally always empty at init: the dialog is
// hydrated per-open from the current garage/global selection, never from
// URI or storage. See getInitialVehicleSelection() in ../common for the
// hydrated paths.
const initSelection: VehicleValue[] = [];

export default combineReducers({
  selection: createReducer(initSelection, (builder) =>
    builder
      .addCase(clearVehicleDialogRequest, () => initSelection)
      .addCase(dialogClosed, () => initSelection)
      .addCase(replaceVehicleValue, (state, { payload, meta: { fitmentFields } }) =>
        updateVehicleSelection(state, payload, fitmentFields),
      )
      .addCase(setVehicleDialogSelection, (_state, { payload }) => payload)
      .addCase(vehicleSelected, () => initSelection)
      .addCase(vehicleDiscardingRequested, () => [])
      .addCase(discardVehicleValue, (state, { payload }) =>
        state.filter((facet) => facet.field !== payload.field),
      ),
  ),
});
